<template>
  <el-dialog
    title="上传文件"
    custom-class="post-upload"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :show-close="false"
    :close-on-click-modal="false"
    width="50%"
    @close="onBeforeClose"
  >
    <el-form ref="form" :model="form" :rules="rules">
      <el-form-item label="文件名" prop="publish_name">
        <el-input v-model="form.publish_name" maxlength="30" placeholder="请输入文件名"></el-input>
      </el-form-item>
      <el-form-item label="文件" prop="file">
        <el-row type="flex" justify="start">
          <el-upload action :show-file-list="false" :auto-upload="false" :on-change="onChange">
            <el-button slot="trigger">上传</el-button>
          </el-upload>
          <el-input readonly v-model="form.file"></el-input>
        </el-row>
        <!-- <p slot="tip" class="el-upload__tip" style="color:#999999">&nbsp;上存的文件大小不能超过30M</p> -->
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="submit" :loading="loading">确 定</el-button>
      <el-button @click="$emit('input', false)">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  data () {
    return {
      loading: false,
      visible: false,
      file: {},
      form: {
        publish_name: '',
        file: ''
      },
      rules: {
        file: { required: true, message: '请上传文件' },
        publish_name: { required: true, message: '请输入文件名' }
      }
    }
  },
  watch: {
    value (val) {
      this.visible = val
    }
  },
  methods: {
    onChange (file) {
      if (file.size / 1024 / 1024 > 30) {
        this.$message.error('文件大小不能超过30MB!')
      } else {
        this.file = file.raw
        this.form.file = file.name
      }
    },
    onBeforeClose () {
      this.$refs.form.resetFields()
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const data = new FormData()
          data.append('publish_name', this.form.publish_name)
          data.append('file', this.file)
          this.$http.post('/publish/add2', data).then(res => {
            if (res.successful) {
              this.$emit('input', false)
              this.$parent.$refs.table.reload()
            }
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.post-upload {
  .el-form .el-form-item:nth-of-type(2) .el-input__inner {
    padding: 0;
    border: none;
  }
  .el-row .el-input{
    margin-left: 4px;
  }
}
</style>
